import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import FileUpload from '../../../shared/components/formComponents/inputs/FileUpload';
import FileRow from '../../components/FileRow';
import VerbText from '../../../shared/components/VerbText';

export default class FileUploadWidget extends Component {
    static propTypes = {
        className: PropTypes.string,
        parentId: PropTypes.string,
        parentType: PropTypes.string,
        files: PropTypes.object,
        handleFile: PropTypes.func,
        showFiles: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }

    /**
     *
     * @param {Object} file
     * @return {Promise.<TResult>}
     */
    handleFileChange = (file) => {
        const { parentId, parentType } = this.props;
        return new Promise((res) => {
            const fileInfo = {
                name: file.name.replace(' ', '_'),
                type: file.type,
                parentId,
                parentType
            };
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onloadend = () => {
                const newFile = reader.result;

                fileInfo.file = newFile;
                fileInfo.size = file.size;

                res(
                    this.props
                        .handleFile(fileInfo)
                        .then(() => {
                            const successMessage = (
                                <VerbText
                                    messageId={'WORKSPACE_FILE_UPLOAD_SUCCESS'}
                                    defaultMessage={'Your file has been uploaded!'}
                                />
                            );

                            this.setState({ error: null, success: successMessage });
                        })
                        .catch(() => {
                            const errorMessage = (
                                <VerbText
                                    messageId={'WORKSPACE_FILE_UPLOAD_FAIL_MESSAGE'}
                                    defaultMessage={'Your file failed to load.'}
                                />
                            );
                            const errorDetailMessage = (
                                <VerbText
                                    messageId={'WORKSPACE_FILE_UPLOAD_FAIL_DETAIL'}
                                    defaultMessage={"Here's why: {message}"}
                                />
                            );

                            const newError = `${errorMessage}\n${errorDetailMessage}`;
                            this.setState({ error: newError, success: null });
                        })
                );
            };
        });
    };

    render() {
        const { className, files = {}, showFiles = true } = this.props;
        const { error, success } = this.state;

        let filesDisplay = null;
        if (showFiles) {
            filesDisplay = Object.values(files).map((file) => <FileRow key={file._id} file={file} />);
        }

        return (
            <div className={cns(className, 'widget', 'fileUploadWidget')}>
                {/* <FileUpload handleChange={this.handleFileChange} /> */}
                <div className={`col-sm-12 ${error ? 'errorMessage' : 'successMessage'}`}>{error || success}</div>
                {filesDisplay}
            </div>
        );
    }
}
